export type EditorThreadAnchorType = 'SUGGESTION' | 'TEXT_RANGE'

export type EditorThreadComment = {
  id: string
  threadId: string
  userId: number | null
  userName: string
  body: string
  createdAt: string
}

export type EditorThread = {
  id: string
  anchorType: EditorThreadAnchorType
  anchorId: string
  comments: EditorThreadComment[]
}

export const anchorKey = (anchorType: EditorThreadAnchorType, anchorId: string): string => `${anchorType}:${anchorId}`
